var _path, _path2, _path3, _path4, _path5, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscount20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17238 47.332C6.67972 48.1827 7.48887 48.8112 8.43871 49.0922L13.0289 50.4503L18.4326 52.0166C19.4816 52.3207 20.6097 52.1758 21.5478 51.6164L46.7963 36.5596C48.6654 35.445 49.277 33.0263 48.1624 31.1573L40.1086 17.6519C38.994 15.7829 36.5753 15.1713 34.7063 16.2859L9.38886 31.3837C8.49132 31.919 7.84317 32.7888 7.58699 33.802L5.16335 43.3867C4.90716 44.3999 5.06394 45.4733 5.59918 46.3708L6.17238 47.332ZM11.3917 43.5154C10.987 42.8368 10.1089 42.6148 9.43026 43.0194C8.75166 43.4241 8.5296 44.3023 8.93428 44.9809C9.33896 45.6595 10.2171 45.8815 10.8957 45.4769C11.5743 45.0722 11.7964 44.194 11.3917 43.5154Z",
    stroke: "#FC916B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1255 28.7371C32.8984 28.2762 33.1673 27.3028 32.7262 26.563C32.285 25.8232 31.3008 25.5971 30.5279 26.058C29.755 26.5189 29.4861 27.4923 29.9272 28.2321C30.3684 28.9719 31.3526 29.198 32.1255 28.7371Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7495 31.8172C40.5224 31.3562 40.7914 30.3829 40.3502 29.6431C39.909 28.9033 38.9248 28.6772 38.1519 29.1381C37.379 29.599 37.1101 30.5724 37.5513 31.3122C37.9924 32.052 38.9766 32.2781 39.7495 31.8172Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5939 23.3438L33.4319 34.8003",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7674 38.6456L15.8162 38.74L15.9075 38.6856L17.087 37.9822L17.1703 37.9325L17.1233 37.8478C16.9637 37.5602 16.9685 37.2408 17.1313 36.9183C17.2957 36.5926 17.6221 36.2639 18.1033 35.977C18.5695 35.6989 18.9869 35.5839 19.3293 35.6136C19.6666 35.6429 19.9412 35.8131 20.1306 36.1307C20.2984 36.412 20.2989 36.7342 20.1432 37.0589C19.9862 37.3862 19.6702 37.7146 19.2099 37.9891C18.3195 38.5201 17.7176 39.1383 17.4412 39.8013C17.163 40.4688 17.2196 41.1705 17.6244 41.8493L18.6561 43.5794L18.7073 43.6652L18.7932 43.614L24.3175 40.3197L24.4034 40.2685L24.3522 40.1826L23.7132 39.1111L23.662 39.0252L23.5761 39.0765L19.278 41.6396L18.9364 41.0669C18.7623 40.7749 18.7612 40.4615 18.9253 40.143C19.0918 39.8196 19.4304 39.4896 19.9377 39.1871C20.8369 38.6508 21.4323 38.047 21.6934 37.3898C21.9566 36.7273 21.8739 36.0268 21.4505 35.3169C21.0488 34.6433 20.4535 34.2509 19.7426 34.1585C19.0351 34.0666 18.2239 34.273 17.3853 34.7731C16.5281 35.2843 15.941 35.8977 15.6596 36.5644C15.3768 37.2342 15.4069 37.9484 15.7674 38.6456ZM28.4943 37.9888C29.4029 37.4469 29.9941 36.689 30.2238 35.8403C30.4537 34.9912 30.3191 34.0607 29.7938 33.1798L28.9907 31.8331C28.4625 30.9474 27.7065 30.3842 26.8494 30.1815C25.9926 29.9789 25.0448 30.1388 24.1361 30.6807C23.2274 31.2226 22.6362 31.9805 22.4072 32.8306C22.1781 33.681 22.3143 34.6138 22.8425 35.4995L23.6455 36.8462C24.1709 37.7271 24.9255 38.2878 25.7818 38.4892C26.6378 38.6906 27.5856 38.5307 28.4943 37.9888ZM27.747 36.7358C27.2159 37.0525 26.6772 37.1363 26.1979 37.0171C25.7186 36.8979 25.2879 36.573 24.9772 36.0521L24.1741 34.7054C23.8635 34.1845 23.7824 33.6511 23.9053 33.1728C24.0283 32.6944 24.3581 32.2603 24.8892 31.9436C25.4204 31.6268 25.959 31.543 26.4383 31.6622C26.9176 31.7814 27.3484 32.1063 27.659 32.6272L28.4621 33.9739C28.7727 34.4948 28.8538 35.0282 28.7309 35.5066C28.608 35.985 28.2782 36.419 27.747 36.7358Z",
    fill: "#FC916B",
    stroke: "#FC916B",
    strokeWidth: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3190_7133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 21.3672C2.11328 21.3672 6.98867 23.1319 8.11566 23.9235",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69141 4.62695C8.78967 6.68333 10.0565 8.64512 11.479 10.4922C12.5015 11.791 15.7674 16.973 15.7674 16.973",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2866 5.16211C26.2866 5.16211 25.3652 10.8106 25.4106 11.0097",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3190_7133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7919,
    height: 23.5911,
    fill: "white",
    transform: "translate(6.21729) rotate(12.6053)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount20);
export default __webpack_public_path__ + "static/media/discount-20.fd4ad9b3e6c7dfd09570a2bd91bf1827.svg";
export { ForwardRef as ReactComponent };